"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const __1 = require("../../..");
const windowWidth_1 = require("../../../utils/windowWidth");
const Button_1 = __importDefault(require("../../Button/Button"));
const SearchBarDropdownMenu_1 = require("./SearchBarDropdownMenu");
const SearchFilterButtons_1 = require("./SearchFilterButtons");
const SearchMultiFilterButtons_1 = require("./SearchMultiFilterButtons");
const SearchBar = (props) => {
    var _a;
    const [searchWord, setSearchWord] = react_1.useState('');
    const [selectedSearchFilter, setSelectedSearchFilter] = react_1.useState(props.defaultSearchFilter);
    const [selectedSearchMultiFilters, setSelectedSearchMultiFilters] = react_1.useState((_a = props.defaultSearchMultiFilters) !== null && _a !== void 0 ? _a : props.searchMultiFilters);
    const column = props.buttons !== undefined && props.buttons.length > 0 ? 'vertical' : '';
    react_1.useEffect(() => {
        if (props.hideInputField === true) {
            return;
        }
        const searchedList = props.allItems.filter((item) => props.doesItemMatchWord(searchWord, item));
        if (!!selectedSearchMultiFilters && props.searchMultiFilters) {
            let filteredItems = [];
            const countResult = {};
            props.searchMultiFilters.forEach((searchMultiFilter) => {
                const itemsByFilter = searchedList.filter((item) => searchMultiFilter.doesItemMatchFilter(item));
                if (selectedSearchMultiFilters.find((selectedFilter) => selectedFilter.key === searchMultiFilter.key)) {
                    filteredItems = filteredItems.concat(itemsByFilter);
                }
                countResult[searchMultiFilter.key] = itemsByFilter.length;
            });
            props.updateItems(filteredItems);
            if (props.onSearchFilterSelect) {
                props.onSearchFilterSelect(selectedSearchMultiFilters);
            }
            if (props.countSearchMultiFiltersItems) {
                props.countSearchMultiFiltersItems(countResult);
            }
        }
        else if (selectedSearchFilter && props.searchFilters) {
            props.updateItems(searchedList.filter((item) => selectedSearchFilter.doesItemMatchFilter(item)));
            if (props.onSearchFilterSelect) {
                props.onSearchFilterSelect([selectedSearchFilter]);
            }
        }
        else {
            props.updateItems(searchedList);
        }
    }, [searchWord, selectedSearchFilter, selectedSearchMultiFilters, !props.hideInputField && props.allItems]);
    const className = classnames_1.default(['search-bar'], {
        'search-bar-hide-input-field': props.hideInputField,
    });
    return (React.createElement("div", { className: className },
        !props.hideInputField &&
            React.createElement("div", { className: `search-field-and-filter-group ${column}` },
                renderSearchField(),
                renderSearchFilterButtons(),
                renderSearchMultiFilterButtons()),
        (props.buttons || props.dropdownMenu) && (React.createElement("div", { className: "buttons-and-dropdown" },
            renderButtons(),
            renderDropdown()))));
    function renderSearchField() {
        return (React.createElement(__1.Search, { searchWord: searchWord, onChange: handleSearch, clearFunction: clearSearch, placeholder: props.searchPlaceHolder }));
    }
    function renderSearchFilterButtons() {
        return (props.searchFilters && (React.createElement(SearchFilterButtons_1.SearchFilterButtons, { filters: props.searchFilters, selectedFilter: selectedSearchFilter, handleFilter: setSelectedSearchFilter })));
    }
    function handleSelectedSearchMultiFilter(selectedFilter) {
        if (!!(selectedSearchMultiFilters === null || selectedSearchMultiFilters === void 0 ? void 0 : selectedSearchMultiFilters.find((filter) => filter.key === selectedFilter.key))) {
            setSelectedSearchMultiFilters(selectedSearchMultiFilters === null || selectedSearchMultiFilters === void 0 ? void 0 : selectedSearchMultiFilters.filter((filter) => filter.key !== selectedFilter.key));
        }
        else {
            selectedSearchMultiFilters !== undefined ?
                setSelectedSearchMultiFilters([...selectedSearchMultiFilters, selectedFilter]) :
                setSelectedSearchMultiFilters([selectedFilter]);
        }
    }
    function renderSearchMultiFilterButtons() {
        return (props.searchMultiFilters && (React.createElement(SearchMultiFilterButtons_1.SearchMultiFilterButtons, { filters: props.searchMultiFilters, selectedFilters: selectedSearchMultiFilters, handleFilter: handleSelectedSearchMultiFilter })));
    }
    function renderButtons() {
        return (props.buttons && (React.createElement(React.Fragment, null, props.buttons.map((button) => {
            return (React.createElement(Button_1.default, { color: "primary", key: button.title, className: 'search-bar-button', size: "md", disabled: button.isDisabled, onClick: button.action }, button.title));
        }))));
    }
    function renderDropdown() {
        if (windowWidth_1.isTabletOrMobile()) {
            return null;
        }
        return (props.dropdownMenu && (React.createElement(SearchBarDropdownMenu_1.SearchBarDropdownMenu, { actions: props.dropdownMenu.actions, isDisabled: props.dropdownMenu.isDisabled })));
    }
    function clearSearch() {
        setSearchWord('');
    }
    function handleSearch(e) {
        setSearchWord(e.target.value);
    }
};
exports.SearchBar = SearchBar;
//# sourceMappingURL=SearchBar.js.map